/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown>, files: NonNullable<unknown>, answered: NonNullable<unknown> }} Artifactpackprogressdone3Inputs */

const en_artifactpackprogressdone3 = /** @type {(inputs: Artifactpackprogressdone3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.events} timeline events · ${i?.files} documents · ${i?.answered} open question(s) answered. The hard part's done.`)
};

const pt_artifactpackprogressdone3 = /** @type {(inputs: Artifactpackprogressdone3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.events} eventos na cronologia · ${i?.files} documentos · ${i?.answered} pergunta(s) em aberto respondida(s). A parte difícil está feita.`)
};

/**
* | output |
* | --- |
* | "{events} timeline events · {files} documents · {answered} open question(s) answered. The hard part's done." |
*
* @param {Artifactpackprogressdone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackprogressdone3 = /** @type {((inputs: Artifactpackprogressdone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackprogressdone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackprogressdone3(inputs)
	return pt_artifactpackprogressdone3(inputs)
});
export { artifactpackprogressdone3 as "artifactPackProgressDone" }